module.exports = __webpack_public_path__ + "img/ic-arrow-down.8a4f516d.svg";